// components/CookieGuard/CookieGuard.tsx
'use client'

import React from 'react'

import { CookieConsent } from '../CookieConsent/CookieConsent'
import { useCookieConsent } from '@/hooks/animation/useCookieConsent'

interface CookieGuardProps {
  children: React.ReactNode
}

export const CookieGuard: React.FC<CookieGuardProps> = ({ children }) => {
  const { consentStatus, isLoading, needsConsent } = useCookieConsent()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  return (
    <>
      {children}
      {needsConsent && <CookieConsent />}
    </>
  )
}